module.exports = __webpack_public_path__ + "static/media/luxlife-award-2026.eb0bd5cb.jpg";